import { citrusStyled } from '@citrus/runtime';
import { highlight as highLightLegacy } from '../styles';
import { highlight as highlightCitron } from '../styles/citrus2022';
export var Highlight = citrusStyled.span('highlight', { legacy: highLightLegacy, citrus2022: highlightCitron });
export var Styled = {
    Highlight: Highlight,
};
